module.exports = __webpack_public_path__ + "static/media/fantasy-flight-games.0e359b25.svg";